import Button from '@algbra/ui/components/Button/Button'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { getIconByName } from '@algbra/ui/icons'
import { navigate } from 'gatsby'
import styles from './DecodedBanner.module.scss'

export type ZoneDecodedBannerProps = {
  __typename: 'StrapiGQL_ComponentZonesDecodedBanner'
  title: string
  description: string
}

export function ZoneDecodedBanner({
  title,
  description,
}: ZoneDecodedBannerProps) {
  return (
    <Whitespace type="md">
      <div className={styles.container}>
        <img src="/images/logo-inverted.svg" alt="Algbra Logo" width={140} />
        <Heading type="xl" className={styles.title}>
          {title}
        </Heading>
        <FreeText
          type="md"
          innerHTML={description}
          className={styles.description}
          color="white"
        >
          {description}
        </FreeText>
        <Button
          onClick={() => navigate('/decoded/')}
          icon={getIconByName('arrow-right')}
          theme="blackTransparent"
          size="normal"
        >
          Visit Event Page
        </Button>
      </div>
    </Whitespace>
  )
}
